module.exports = __webpack_public_path__ + "static/media/stage_3.8f77e4d7.png";